import { AdapterLuxon } from "@mui/x-date-pickers-pro/AdapterLuxon";
import { DateTime } from "luxon";

export class LuxonAdapter extends AdapterLuxon {
  constructor(options?: any) {
    super({ locale: "en-US", ...options });
  }

  startOfWeek = (value: DateTime): DateTime => {
    const currentWeekday = value.weekday;
    const daysToSubtract = currentWeekday === 7 ? 0 : currentWeekday;
    return value.minus({ days: daysToSubtract }).startOf("day");
  };

  endOfWeek = (value: DateTime): DateTime => {
    const currentWeekday = value.weekday;
    const daysToAdd = currentWeekday === 7 ? 6 : 6 - currentWeekday;
    return value.plus({ days: daysToAdd }).endOf("day");
  };

  getWeekdays = (): string[] => {
    return [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
  };

  getWeekArray = (value: DateTime): DateTime[][] => {
    const start = this.startOfMonth(value);
    const end = this.endOfMonth(value);

    let current = this.startOfWeek(start);
    const weeks: DateTime[][] = [];

    while (current <= end) {
      const week: DateTime[] = [];
      for (let i = 0; i < 7; i++) {
        week.push(current);
        current = current.plus({ days: 1 });
      }
      weeks.push(week);
    }

    return weeks;
  };
}
